<template>
  <div id="resourceItemComp" @click="handleClick">
    <div class="left">
      <i class="icon icon-file icon-0" v-if="type === 'folder'"></i>
      <i class="icon icon-file" v-else :class="[fileIcon[item.suffix]||'icon-1']"></i>
      <div class="name text-ellipsis">{{item.name}}</div>
    </div>
    <div class="right">
      <div class="date">{{item.timeStamp | formatDate('yyyy-MM-dd hh:mm')}}</div>
      <van-image class="icon" :src="require('@/assets/images/research/icon_arrow_02.png')" v-if="type === 'folder'" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'ResourceItemComp',
  props: {
    item: {
      type: Object,
      default: () => {}
    },
    projectId: {
      type: [String, Number],
      default: ''
    },
    type: {
      type: String,
      default: 'file'
    }
  },
  data () {
    return {
      // 文件图标
      fileIcon: {
        'png': 'icon-2',
        'jpg': 'icon-2',
        'jpeg': 'icon-2',
        'gif': 'icon-2',
        'svg': 'icon-2',
        'ppt': 'icon-3',
        'pptx': 'icon-3',
        'mp4': 'icon-4',
        'txt': 'icon-5',
        'doc': 'icon-6',
        'docx': 'icon-6',
        'wps': 'icon-6',
        'pdf': 'icon-6',
        'mp3': 'icon-7',
        'zip': 'icon-8',
        'rar': 'icon-8',
        '7z': 'icon-8',
        'xls': 'icon-9',
        'xlsx': 'icon-9',
        'excel': 'icon-9'
      }
    };
  },
  methods: {
    handleClick () {
      const { item, type, $router, $preview365, projectId } = this;
      if (type === 'folder') {
        $router.push({ name: 'Folder', query: { title: item.name, projectId, parentId: item.id } });
      } else {
        $preview365(item.url);
      }
    }
  }
};
</script>

<style lang="less" scoped>
#resourceItemComp {
  padding: 20px 28px;
  background-color: #fff;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  .left {
    flex: 1;
    display: flex;
    align-items: center;
    .icon-file{
      width: 52px;
      height: 52px;
      margin-right: 20px;
      .loop-icon(0,'fileIcon/icon_file',10);
    }
    .name {
      flex: 1;
      width: 0;
      font-size: 24px;
      color: #333;
    }
  }
  .right {
    display: flex;
    align-items: center;
    margin-left: 16px;
    .date {
      font-size: 24px;
      font-weight: 500;
      color: #999AAA;
    }
    .icon {
      margin-left: 16px;
      width: 26px;
      height: 26px;
    }
  }
}
</style>